<div class="customers-container">
  <div class="customers-body">
    <router-outlet />
  </div>
</div>
